import { createSelector } from '@ngrx/store';
import { parseMidTierProgramParentIds } from '../../shared/helpers/mid-tier-program.helper';
import { FlagsmithFlags } from '../../shared/models/flagsmith-flags.enum';
import { selectFlagsmithFeatureFlag } from './flagsmith-feature-flag.selectors';

type MidTierProgramSelection = {
  enabled: boolean;
  parentIds: string[];
  error?: string;
};

/**
 * Derives Mid Tier Program membership from the `product_mid_tier_program` feature flag: the feature
 * is off unless the flag is enabled, and the enrolled parent IDs come from the flag value (a JSON
 * array). A malformed value surfaces `error` so consumers can log a warning.
 */
export const selectMidTierProgram = createSelector(
  selectFlagsmithFeatureFlag(FlagsmithFlags.ProductMidTierProgram),
  (flag): MidTierProgramSelection => {
    const enabled = Boolean(flag?.enabled);
    if (!enabled) {
      return { enabled, parentIds: [] };
    }
    return { enabled, ...parseMidTierProgramParentIds(flag?.value) };
  }
);
